export const API_URL = process.env.REACT_APP_API;
export const URL_DOCU = process.env.REACT_APP_DOCUM;
export const URL_PERFIL = process.env.REACT_APP_PERFIL;
export const URL_DEPO = process.env.REACT_APP_DEPO;
export const URL_DEPO_COP = process.env.REACT_APP_DEPO_COP;
export const GKEY = process.env.REACT_APP_GKEY;
export const URL_GOLDEN = process.env.REACT_APP_URL_GOLDEN;
export const GPKEY = process.env.REACT_APP_GPUB_KEY;
export const RUTA_INFO = process.env.REACT_APP_RUTA_INFO;
